<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.daifu_list_auto_withdrawal") }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.w-100
              .form-group.col-md-4.col-lg-3.col-3.mb-1
                b-input-group(size="sm")
                  b-form-select.col-4(v-model="searchType" size="sm" @input="resetInput()")
                    option(value="operator" v-if="!isOperator") {{ $t('ui.operator') }}
                    option(value="member" v-else-if="isOperator") {{ $t('ui.member') }}
                    option(value="ticket") {{ $t('ui.ticket') }}
                  template(v-if="['operator'].includes(searchType)")
                    DebounceInput(autofocus type="text" v-model="operatorID" :placeholder="$t('message.search_by_' + searchType)" @enter="getTicketList(true)" size="sm")
                  template(v-else-if="['member'].includes(searchType)")
                    DebounceInput(autofocus type="text" v-model="memberID" :placeholder="$t('ui.member')" @enter="getTicketList()" size="sm")
                  template(v-if="['ticket'].includes(searchType)")
                    DebounceInput(autofocus type="text" v-model="ticketId" :placeholder="$t('message.search_by_' + searchType)" @enter="getTicketList(true)" size="sm")
              template(v-if="['operator', 'member'].includes(searchType)")
                template(v-if="operatorID != ''")
                  .form-group.col-md-4.col-lg-3.col-3.mb-1
                    b-input-group(size="sm")
                      b-input-group-text(slot="prepend")
                        i.fa.fa-search
                      DebounceInput(autofocus type="text" v-model="memberID" :placeholder="$t('ui.member')" size="sm")
                .form-group.col-md-4.col-lg-3.col-3.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t('ui.status') }}
                    b-form-select(v-model="ticketStatus" :disabled="loading" size="sm" @change="getTicketList(true)")
                      option(value="") {{ $t('ui.all') }}
                      option(value="REJECTED") {{ $t('ui.rejected') }}
                      option(value="PROCESSED") {{ $t("ui.processed") }}
                      option(value="PROCESSING") {{ $t("ui.processing") }}
                      option(value="AUDIT") {{ $t("ui.audit") }}
                .form-group.col-12.mb-1
                  DateRangePicker(:value="dateRange" @update="getData")
              .form-group.col-12.mb-1
                SubmitButton(
                  icon="fa fa-search"
                  :loading="loading"
                  :text="$t('ui.search')"
                  type="button"
                  @click="getTicketList(true)"
                  variant="primary"
                  size="sm"
                ).mr-2
                jsonToExcel(v-if="withdrawalList.length > 0" mode="TicketListAutoWithdrawal" tbl="tblTicket" :date="dateRange" btnTxt="export_one").mr-2
                jsonToExcelFull(v-if="withdrawalListFull.length > 0 && $helpers.showExportAll(dateRange) == true" mode="TicketListAutoWithdrawal" tbl="tblTicketFull" :date="dateRange" btnTxt="export_all" type="0" :loading2="loading2").mr-2
                ticketListAutoWithdrawalExport(v-if="withdrawalList.length > 0" :tbl="withdrawalList" :ticketStatus="ticketStatus" tblId="tblTicket").mr-2
                ticketListAutoWithdrawalExportFull(v-if="withdrawalListFull.length > 0 && $helpers.showExportAll(dateRange) == true" :tbl="withdrawalListFull" :ticketStatus="ticketStatus" tblId="tblTicketFull")

          .card-body
            .row
              .col-12
                ul#tickettab.nav.nav-tabs(role='tablist')
                  li.nav-item
                    a#withdrawal-tab.nav-link.active(data-toggle='tab' href='#withdrawal-content' role='tab' aria-controls='withdrawal' aria-selected='false')
                      span {{ $t("ui.withdrawal") }}
                      b-badge.ticket-total-badge(variant="danger" size="sm").ml-1 {{ wdwTotalRow }}

                #tickettabcontent.tab-content.tab-bordered
                  #withdrawal-content.tab-pane.active.show(role='tabpanel' aria-labelledby='withdrawal-tab')
                    .card.mb-0
                      .card-body
                        .row
                          .col-10.mb-1
                            b-pagination.float-left(
                              size="sm"
                              hide-ellipsis
                              :total-rows="wdwTotalRow"
                              :per-page="getPageSize"
                              v-model="currentWdwPage"
                              @input="changedWdwPage($event)").mb-1
                          .col-2.mb-1
                            b-input-group(:prepend="$t('ui.page_size')" size="sm")
                              b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedWdwPageSize" size="sm")
                          .col-12
                            .clusterize-scroll.table-responsive
                              table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                                thead.thead-light
                                  tr
                                    th.text-center(width="3%")
                                      span #
                                    th(width="5%")
                                      span(:title="$t('ui.id')") {{ $t('ui.id') }}
                                    th(width="8%")
                                      span(:title="$t('ui.operator_id')") {{ $t('ui.operator_id') }}
                                    th(width="8%")
                                      span(:title="$t('ui.member')") {{ $t('ui.member') }}
                                    th.text-right(width="8%")
                                      span(:title="$t('ui.amount')") {{ $t('ui.amount') }}
                                    th(width="8%")
                                      span(:title="$t('ui.sender_bank_acc_no')") {{ $t('ui.short.sender_bank_acc_no') }}
                                    th(width="8%")
                                      span(:title="$t('ui.recipient_bank_id')") {{ $t('ui.short.recipient_bank_id') }}
                                    th(width="10%")
                                      span(:title="$t('ui.recipient_bank_acc_no')") {{ $t("ui.short.recipient_bank_acc_no") }}
                                    th.text-center(width="5%")
                                      span(:title="$t('ui.status')") {{ $t("ui.status") }}
                                    th.text-center(width="8%")
                                      span(:title="$t('ui.action')") {{ $t("ui.action") }}
                                    th(width="1%")
                                      span(:title="$t('ui.remark')") {{ $t("ui.remark") }}
                                    th(width="8%")
                                      span(:title="$t('ui.created_by')") {{ $t("ui.created_by") }}
                                    th.text-right(width="10%")
                                      span(:title="$t('ui.approve_time')") {{ $t("ui.approve_time") }}
                                    th.text-right(width="10%")
                                      span(:title="$t('ui.audit_time_created')") {{ $t("ui.audit_time_created") }}
                                tbody.clusterize-content
                                  tr(v-if="withdrawalList.length == 0")
                                    td(colspan="14").text-center
                                      span {{ $t('message.no_data_available') }}
                                  tr(v-for="(item, index) in withdrawalList" :class="$helpers.rowClassTicket(item, 'withdrawal')")
                                    td.text-center
                                      span(:title="((currentWdwPage - 1) * getPageSize + index + 1)") {{ ((currentWdwPage - 1) * getPageSize + index + 1) }}
                                    td
                                      span.d-block(:title="item.id") {{ item.id }}
                                      span.small.text-info.d-block(:title="getRefNo(item.sender_bank_id, item.id, item.prefix_w, item.prefix_delimiter)") {{ getRefNo(item.sender_bank_id, item.id, item.prefix_w, item.prefix_delimiter) }}
                                    td
                                      span(:title="item.parent_id") {{ item.parent_id }}
                                    td
                                      span.font-weight-bold(:title="item.member_id")
                                        b-link.clickable(href="javascript:void(0);" @click="onInfo(item)") {{ item.member_id }}
                                    td.text-right
                                      span.font-weight-bold.d-block(:title="$n(item.amount, 'currency')" :class="$helpers.fontClassName(item.amount)") {{ $n(item.amount, 'currency') }}
                                    td
                                      span(:title="item.sender_bank_acc_no") {{ item.sender_bank_acc_no }}
                                      br 
                                      span(:title="item.sender_payment_mode") {{ item.sender_payment_mode }}&nbsp;
                                    td
                                      span(:title="item.recipient_bank_id") {{ item.recipient_bank_id }}
                                    td
                                      span(:title="item.recipient_bank_acc_no") {{ item.recipient_bank_acc_no }}
                                    td.text-center
                                      span(:class="$helpers.badgeClass(item.status)") {{ item.status.trim().toUpperCase() }}
                                      //- span(v-if="item.status.trim().toUpperCase() == 'PENDING'" :class="$helpers.badgeClass(item.status)") {{ item.status.trim().toUpperCase() }}
                                      //- span(v-if="item.status.trim().toUpperCase() == 'PROCESSED'" :class="$helpers.badgeClass(item.status)") {{ item.status.trim().toUpperCase() }}
                                      //- span(v-if="item.status.trim().toUpperCase() == 'REJECTED'" :class="$helpers.badgeClass(item.status)") {{ item.status.trim().toUpperCase() }}
                                      //- span(v-if="item.status.trim().toUpperCase() == 'PROCESSING'" :class="$helpers.badgeClass(item.status)") {{ item.status.trim().toUpperCase() }}
                                      //- span(v-if="item.status.trim().toUpperCase() == 'REVIEW'" :class="$helpers.badgeClass(item.status)") {{ item.status.trim().toUpperCase() }}
                                      //- span(v-if="item.status.trim().toUpperCase() == 'AUDIT'" :class="$helpers.badgeClass(item.status)") {{ item.status.trim().toUpperCase() }}
                                    td.text-center
                                      span
                                        a.fa.fa-search.btn.btn-ssm.btn-primary(href="javascript:void(0)" @click="getTicketDetail(item)" :title="$t('ui.view')")
                                      template(v-if="isEditAccess")
                                        span.ml-1(v-if="item.status.trim().toUpperCase() == 'PROCESSED' && isAdminMaster")
                                          a.fa.fa-ban.btn.btn-ssm.btn-danger(href="javascript:void(0)" @click="rejectApprovedTicket(item, $event)" :title="$t('ui.reject')")
                                        span.ml-1(v-if="item.status.trim().toUpperCase() == 'PROCESSING' && isAdminMaster && showActionButton('ticketwithdrawalrollback')")
                                          a.fa.fa-undo.btn.btn-ssm.btn-warning(href="javascript:void(0)" @click="rollbackProcessingTicket(item, $event)" :title="$t('ui.rollback')")
                                    td
                                      span(:title="item.remark") {{ item.remark }}
                                    td
                                      span(:title="item.created_by") {{ item.created_by }}
                                    td.text-right
                                      span(v-if="item.modified_date" :title="$moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss') }}
                                    td.text-right
                                      span(v-if="item.created_date" :title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}

    ticketdetail(ref="ticketdetail" :ticketId="selectedTicketId" @failed="handleFailed")
    rejectapprovedticket(ref="rejectapprovedticket" :ticketId="selectedTicketId" @clicked="afterRejectApprovedTicket" @failed="handleFailed")
    rollbackprocessingticket(ref="rollbackprocessingticket" :ticketId="selectedTicketId" @clicked="afterRollbackProcessingTicket" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import ticketdetail from "@/components/ticket/ticketDetail.vue";
import rejectapprovedticket from "@/components/ticket/rejectApprovedTicket.vue";
import DateRangePicker from "@/library/DateRangePicker.vue";
import rollbackprocessingticket from "@/components/ticket/rollbackProcessingTicket.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import jsonToExcelFull from "@/library/jsonToExcelFull.vue";
import jsonToExcel from "@/library/jsonToExcel.vue";
import ticketListAutoWithdrawalExport from "@/components/ticket/ticketListAutoWithdrawalExportFull.vue";
import ticketListAutoWithdrawalExportFull from "@/components/ticket/ticketListAutoWithdrawalExportFull.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    ticketdetail,
    rejectapprovedticket,
    DateRangePicker,
    rollbackprocessingticket,
    jsonToExcelFull,
    jsonToExcel,
    ticketListAutoWithdrawalExport,
    ticketListAutoWithdrawalExportFull,
  },
  data: () => ({
    loading2: false,
    loading: false,
    withdrawalListFull: [],
    withdrawalList: [],
    currentWdwPage: 1,
    wdwTotalRow: 0,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    dateRange: {
      startDate: null,
      endDate: null,
    },
    locale: {
      format: "YYYY-MM-DD",
      useCurrent: true
    },
    ticketStatus: "",
    requestType: null,
    selectedTicketId: null,
    selectedTicket: null,
    selectedMemberId: null,
    al: null,
    search: '',
    ticketId: "",
    searchType: "ticket",
    operatorID: "",
    memberID: "",
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    getAuthorityRole() {
      if (this.$store.getters.authorityRole)
        return this.$store.getters.authorityRole;

      return '';
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_ticketlistautowithdrawal");
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
  },
  mounted: function() {
    this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
    this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
    // this.$refs.search_btn.$el.click();
    this.getTicketList(true);
  },
  methods: {
    resetInput() {
      this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.search = "";
      this.ticketStatus = "";
      this.ticketId = "";
    },
    showActionButton(action) {
      if (this.getAuthorityRole == 'SUB_PRI') {
        if (this.$store.getters.accountAuthority) {
          var roles = this.$store.getters.accountAuthority[0].authority_option;
          roles =  roles && roles.length > 0 ? roles.split(',') : [];
          if (roles.includes(action))
            return true;
          else
            return false;
        } else
          return false;
      } else {
        return true;
      }
    },
    getRefNo: function(bank_id, id, prefix, delimiter) {
      return this.$helpers.getPaymentGatewayRefNoSetMember(bank_id, id, prefix, delimiter);
    },
    rejectApprovedTicket: function(e) {
      this.selectedTicketId = e.id;
      this.$refs.rejectapprovedticket.$refs.rejectApprovedTicket.show();
    },
    afterRejectApprovedTicket: function() {
      this.getTicketList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_ticket"), this.$t("message.success"), "success");
    },
    rollbackProcessingTicket: function(e) {
      this.selectedTicketId = e.id;
      this.$refs.rollbackprocessingticket.$refs.rollbackProcessingTicket.show();
    },
    afterRollbackProcessingTicket: function() {
      this.getTicketList();
      this.$helpers.showDialog(this.$t("ui.combine.rollback_processing_ticket"), this.$t("message.success"), "success");
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getTicketList(true);
    },
    getTicketList(isSearch) {
      if (this.checkDateRange()) {
        this.getWithdrawalList(isSearch);
        if (this.$helpers.showExportAll(this.dateRange) == true) {
          this.getWithdrawalListFull(isSearch);
        }
      } else {
        this.withdrawalList = [];
        this.withdrawalListFull = [];
        this.wdwTotalRow = 0;
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    openAttachment(obj) {
      this.$store.dispatch("user/setAttachmentPath", obj.attachment_path);
      let routeData = this.$router.resolve({path: '/attachment'});
      window.open(routeData.href, '_blank', "toolbar=yes,scrollbars=yes,resizable=yes,top=100,left=250,width=1500,height=800");
    },
    onInfo(e) {
      this.$store.dispatch("user/setSelectedOperatorID", e.parent_id);
      this.$router.push("/account/operator");
    },
    getWithdrawalListFull: function(isSearch) {
      let url = config.ticketListAutoWithdrawalUrl();

      if (isSearch) this.currentWdwPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate,
        page_number: this.currentWdwPage,
        page_size: -1
      };

      if(this.searchType == 'operator' || this.searchType == 'member') {
        json.ticket_status = this.ticketStatus
        json.operator_id = this.operatorID
        json.member_id = this.memberID
      } else {
        json.ticket_id = this.ticketId ? this.$helpers.getTicketId(this.ticketId) : null
      }

      this.loading2 = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading2 = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.withdrawalListFull = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading2 = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getWithdrawalList: function(isSearch) {
      let url = config.ticketListAutoWithdrawalUrl();

      if (isSearch) this.currentWdwPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate,
        page_number: this.currentWdwPage,
        page_size: this.getPageSize
      };

      if(this.searchType == 'operator' || this.searchType == 'member') {
        json.ticket_status = this.ticketStatus
        json.operator_id = this.operatorID
        json.member_id = this.memberID
      } else {
        json.ticket_id = this.ticketId ? this.$helpers.getTicketId(this.ticketId) : null
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.withdrawalList = response.data.dt;
                this.wdwTotalRow = this.withdrawalList.length > 0 ? this.withdrawalList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getTicketDetail: function(e) {
      this.selectedTicketId = e.id;
      this.$refs.ticketdetail.$refs.ticketDetail.show();
    },
    rejectTicket: function(e) {
      this.selectedTicketId = e.id;
      this.$refs.rejectticket.$refs.rejectTicket.show();
    },
    changedWdwPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentWdwPage = 1;
      this.getWithdrawalList(true);
    },
    changedWdwPage: function(pageNo) {
      this.currentWdwPage = pageNo;
      this.getWithdrawalList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>